import React from 'react';
import { Modal, TextContainer, Stack } from '@shopify/polaris';
import { Icons } from '../../../util/superGrossIconFile';

const FeatureConfirmModal = ({ feature, onCancel, onFeatureConfirm }) => (
  <Modal
    open
    onClose={onCancel}
    title="Confirm Your Action"
    primaryAction={{
      content: 'Enable Feature',
      onAction: onFeatureConfirm,
    }}
    secondaryActions={[
      {
        content: 'Cancel',
        onAction: onCancel,
      },
    ]}
  >
    <Modal.Section>
      <Stack vertical>
        <Stack.Item>
          <section style={{ padding: 'var(--p-space-1)' }}>
            <TextContainer>
              <p>Please read the following carefully before proceeding.</p>
            </TextContainer>
          </section>
          <section
            style={{
              padding: 'var(--p-space-5)',
              fontSize: 'large',
              lineHeight: '1.5',
            }}
          >
            <TextContainer>
              <div
                style={{
                  fontSize: 'large',
                }}
              >
                <p>
                  Enabling this feature requires updating your permissions. will
                  need to grant access to the following scope(s)
                </p>
              </div>
              <div
                style={{
                  padding: '20px',
                }}
              >
                {Object.entries(feature.shopifyScopes).map(([key, value]) => (
                  <div key={key}>
                    <p
                      style={{
                        fontSize: 'larger',
                        fontWeight: 'bold',
                      }}
                    >
                      {key}
                    </p>
                    <p
                      style={{
                        fontSize: 'medium',
                        fontWeight: '200',
                      }}
                    >
                      {value}
                    </p>
                  </div>
                ))}
              </div>
            </TextContainer>
          </section>
          <section style={{ padding: 'var(--p-space-5)' }}>
            <TextContainer>
              <div>
                <div style={{ display: 'inline-block', width: '10%' }}>
                  {Icons.messageIcon}
                </div>
                <div
                  style={{
                    display: 'inline-block',
                    width: '90%',
                    verticalAlign: 'top',
                  }}
                >
                  <p>
                    If you choose to disable this feature in the future, please
                    contact our support team using the Intercom button at the
                    bottom left of your screen or by emailing
                    support@uporder.com.
                  </p>
                </div>
              </div>
            </TextContainer>
          </section>
        </Stack.Item>
      </Stack>
    </Modal.Section>
  </Modal>
);

export default FeatureConfirmModal;
